import * as LoadingStatus from '@dragonfruit/constants/loadingState';

const typePrefix = action => `TERMS_DIALOG/${action}`;

export const types = {
  AGREE_NEW_TERMS_REQUEST: typePrefix('AGREE_NEW_TERMS_REQUEST'),
  AGREE_NEW_TERMS_SUCCESS: typePrefix('AGREE_NEW_TERMS_SUCCESS'),
  AGREE_NEW_TERMS_FAILURE: typePrefix('AGREE_NEW_TERMS_FAILURE'),

  DECLINE_NEW_TERMS: typePrefix('DECLINE_NEW_TERMS'),

  SHOW_TERMS_DIALOG: typePrefix('SHOW_TERMS_DIALOG'),
  HIDE_TERMS_DIALOG: typePrefix('HIDE_TERMS_DIALOG'),
};

export const actions = {
  agreeNewTerms: () => ({
    type: types.AGREE_NEW_TERMS_REQUEST,
  }),
  agreeNewTermsSuccess: () => ({
    type: types.AGREE_NEW_TERMS_SUCCESS,
  }),
  agreeNewTermsFailure: () => ({
    type: types.AGREE_NEW_TERMS_FAILURE,
  }),
  declineNewTerms: () => ({
    type: types.DECLINE_NEW_TERMS,
  }),
  showTermsDialog: () => ({
    type: types.SHOW_TERMS_DIALOG,
  }),
  hideTermsDialog: () => ({
    type: types.HIDE_TERMS_DIALOG,
  }),
};

const initialState = {
  loadingStatus: LoadingStatus.EMPTY,
  showTermsDialog: false,
};

/*eslint-disable complexity */
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.AGREE_NEW_TERMS_REQUEST:
      return {
        ...state,
        loadingStatus: LoadingStatus.LOADING,
      };
    case types.AGREE_NEW_TERMS_SUCCESS:
      return {
        ...state,
        loadingStatus: LoadingStatus.READY,
        showTermsDialog: false,
      };
    case types.AGREE_NEW_TERMS_FAILURE:
      return {
        ...state,
        loadingStatus: LoadingStatus.ERROR,
        showTermsDialog: false,
      };
    case types.SHOW_TERMS_DIALOG:
      return {
        ...state,
        showTermsDialog: true,
      };
    case types.DECLINE_NEW_TERMS:
      return {
        ...initialState,
      };
    case types.HIDE_TERMS_DIALOG:
      return {
        ...state,
        showTermsDialog: false,
      };
    default:
      return state;
  }
};

export default reducer;

export const getTermsDialogStatus = state => state.termsDialog.showTermsDialog;



// WEBPACK FOOTER //
// ./app/redux/termsDialog.js